import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Logo } from "@/components/site/Logo";
import { LeadsTab } from "@/components/admin/LeadsTab";
import { GalleryTab } from "@/components/admin/GalleryTab";
import { BrandingTab } from "@/components/admin/BrandingTab";
import { api } from "@/lib/api";

const TAB_CLS = "rounded-none border border-white/10 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-300 data-[state=active]:border-brand data-[state=active]:bg-brand data-[state=active]:text-ink";

export default function Admin() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => nav("/admin/login"));
  }, [nav]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => null);
    nav("/admin/login");
  };

  if (!user) return <div className="grid min-h-screen place-items-center bg-ink font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Loading…</div>;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-ink text-bone">
      <header className="border-b border-white/10">
        <div className="mx-auto flex h-[72px] max-w-[1300px] items-center justify-between px-5 md:px-8">
          <Logo />
          <div className="flex items-center gap-2">
            <Link data-testid="admin-view-site" to="/" className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-300 hover:border-brand"><ExternalLink className="h-3.5 w-3.5" /> Site</Link>
            <button data-testid="admin-logout-button" onClick={logout} className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-300 hover:border-brand"><LogOut className="h-3.5 w-3.5" /> Logout</button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1300px] px-5 py-10 md:px-8">
        <h1 className="font-display text-3xl font-black uppercase md:text-4xl">Dashboard</h1>
        <p className="mt-1 text-sm text-zinc-400">Signed in as {user.email}</p>
        <Tabs defaultValue="leads" className="mt-8">
          <TabsList className="h-auto flex-wrap justify-start gap-2 bg-transparent p-0">
            <TabsTrigger data-testid="admin-tab-leads" value="leads" className={TAB_CLS}>Quotes & messages</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-gallery" value="gallery" className={TAB_CLS}>Photos & videos</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-branding" value="branding" className={TAB_CLS}>Logo & colors</TabsTrigger>
          </TabsList>
          <TabsContent value="leads" className="mt-8"><LeadsTab /></TabsContent>
          <TabsContent value="gallery" className="mt-8"><GalleryTab /></TabsContent>
          <TabsContent value="branding" className="mt-8"><BrandingTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
